module.exports = __webpack_public_path__ + "img/404.fe3546ab.jpg";